import { useEventLogging } from '@innovamat/event-logging';
import { useEffect, useRef } from 'react';
import { useCurrentNavigationValues } from '../../navigation';
import type { FormatBanner } from '../types';

type Props = {
  banner: FormatBanner;
};

function useSendShowEvent({ banner }: Props): null {
  const { currentPage, getTypeOfPagePermission } = useCurrentNavigationValues();
  const { setEventData } = useEventLogging();
  const isSentRef = useRef(false);

  useEffect(() => {
    if (!banner || !currentPage || isSentRef.current) return;
    setEventData('banner_shown', {
      banner_name: banner.title,
      banner_id: banner.id,
      page_id: currentPage?.fullPageId || currentPage?.demoPageId,
      page_name: currentPage?.value,
      page_type: currentPage ? getTypeOfPagePermission(currentPage) : undefined,
    });
    isSentRef.current = true;
  }, [banner, currentPage, getTypeOfPagePermission, setEventData]);

  return null;
}

export { useSendShowEvent };
